type TCallBack = () => Promise<any>

type TRedirect = () => void

export const dispatchClosedAuthMiddleware = async (
  callBack: TCallBack,
  redirect?: TRedirect
): Promise<void> => {
  return callBack().then((res) => {
    if (res?.payload?.code === 401 && redirect) {
      redirect()
    }

    return res
  })
}
